__turbopack_context__.v({
  "button": "SubscribeForm-module-scss-module__hOuJ4q__button",
  "error": "SubscribeForm-module-scss-module__hOuJ4q__error",
  "form": "SubscribeForm-module-scss-module__hOuJ4q__form",
  "formWrapper": "SubscribeForm-module-scss-module__hOuJ4q__formWrapper",
  "hero": "SubscribeForm-module-scss-module__hOuJ4q__hero",
  "input": "SubscribeForm-module-scss-module__hOuJ4q__input",
  "success": "SubscribeForm-module-scss-module__hOuJ4q__success",
  "withError": "SubscribeForm-module-scss-module__hOuJ4q__withError",
});
